<jha-dialog-box
  jhaTitle="Symbol Characters"
  [(jhaShowDialog)]="showDialog">
  <p>
    At least 1 of the following symbol characters must be included in the
    password:
  </p>

  <div class="row">
    <div class="col-md-4">
      <table style="width: 100%">
        <tr>
          <td>
            <li>exclamation point</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">!</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>pound sign</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">#</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>dollar sign</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">$</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>percent sign</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">%</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>ampersand</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">&</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>single quote</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">'</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>double quote</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">"</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>left parenthesis</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">(</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>right parenthesis</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">)</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>asterisk</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">*</span></strong>
          </td>
        </tr>
      </table>
    </div>

    <div class="col-md-4">
      <table style="width: 100%">
        <tr>
          <td>
            <li>plus</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">+</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>minus</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">-</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>comma</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">,</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>period</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">.</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>forward slash</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">/</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>back slash</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">\</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>colon</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">:</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>semicolon</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">;</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>less than</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">&lt;</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>equals</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">=</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>greater than</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">&gt;</span></strong>
          </td>
        </tr>
      </table>
    </div>

    <div class="col-md-4">
      <table style="width: 100%">
        <tr>
          <td>
            <li>question mark</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">?</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>at sign</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">&#64;</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>left square bracket</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">[</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>right square bracket</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">]</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>caret</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">^</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>underscore</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">_</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>backquote</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">`</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>left curly brace</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">&#123;</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>right curly brace</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">&#125;</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>pipe</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">|</span></strong>
          </td>
        </tr>

        <tr>
          <td>
            <li>tilde</li>
          </td>

          <td>
            <strong><span class="jha-bright-text-label">~</span></strong>
          </td>
        </tr>
      </table>
    </div>
  </div>

  <jha-dialog-box-button
    id="closeButtonCP"
    jhaText="Close"
    (click)="closeDialog()"
    jhaButtonStyle="Primary"></jha-dialog-box-button>
</jha-dialog-box>
